module.exports = __webpack_public_path__ + "img/shooting12.8237c60c.jpeg";